import { FeApi } from '@/api/fe-api';
import { PageUrlKey } from '@/entities/page-url-key';

export type FeDefaultLandingPage =
  FeApi.PatchedUpdateUserPreferencesInputRequest['default_landing_page'];

export function defaultLandingPageMapper(
  landingPage: FeDefaultLandingPage,
): PageUrlKey | undefined {
  if (!landingPage) {
    return undefined;
  }

  if (landingPage === '/') {
    return PageUrlKey.DEFAULT_LANDING_PAGE;
  }

  const pathWithoutSlash = landingPage.startsWith('/')
    ? landingPage.slice(1)
    : landingPage;

  const pageUrlKey = Object.values(PageUrlKey).find(
    (key) => key === pathWithoutSlash,
  );

  return pageUrlKey;
}

export function defaultLandingPageReverseMapper(
  landingPage: PageUrlKey,
): FeDefaultLandingPage | undefined {
  if (landingPage === PageUrlKey.DEFAULT_LANDING_PAGE) {
    return '/';
  }

  return `/${landingPage}`;
}
